<h2 mat-dialog-title>{{ "generateOfflineOptDemo" | translate }}</h2>

<mat-dialog-content>
  <mat-form-field class="full-width" style="width: 100%">
    <mat-label>{{ "expirationDate" | translate }}</mat-label>
    <input matInput type="date" [formControl]="expirationDate" required />
    <mat-error *ngIf="expirationDate.hasError('required')">
      {{ "expirationDateRequired" | translate }}
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
  <button mat-raised-button color="primary" (click)="confirm()" [disabled]="expirationDate.invalid">
    {{ "confirm" | translate }}
  </button>
</mat-dialog-actions>
